import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import {
  MeetingRoomBookingViewPanel,
  selectHospitalityCostCenter,
  selectHospitalityInstructions,
  setDialogPanel,
  setHospitalityCostCenter,
  setHospitalityInstructions
} from "../../models/meeting-room-booking-dialog.duck";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { useTranslation } from "react-i18next";
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import TextField from '@shared/ui/atoms/TextField';

export function AddInstructionsPanel(props: Props) {
  const dispatch = useDispatch();
  const textRef = useRef<any>(null);
  const {t} = useTranslation();
  const hospitalityInstruction = useSelector(selectHospitalityInstructions);
  const storedCostCenter = useSelector(selectHospitalityCostCenter);
  const [costCenter, setCostCenter] = useState(storedCostCenter || '')
  const [instructions, setInstructions] = useState(hospitalityInstruction || '');

  const onCancelClicked = () => {
    dispatch(setDialogPanel(MeetingRoomBookingViewPanel.MeetingRoomBooking));
  }

  const onConfirmClicked = () => {
    dispatch(setDialogPanel(MeetingRoomBookingViewPanel.MeetingRoomBooking));
    dispatch(setHospitalityInstructions(instructions))
  }

  const onTextChange = (val: string) => {
    if (val.length < 100) {
      setInstructions(val);
    } else {
      setInstructions(val.substring(0, 100));
    }
  }

  const onCostCenterFieldChanged = (val: string) => {
    setCostCenter(val);
    dispatch(setHospitalityCostCenter(val));
  }

  return (
    <>
      <Content>
        <HeadlineMedium style={{marginBottom: 24}}>{t('hospitality.instructions-title')}</HeadlineMedium>
        <BodyRegular style={{marginBottom: 8}} weight={600} colour={Colours.darkGrey}>{t('hospitality.cost-center')}</BodyRegular>
        <TextField onChange={onCostCenterFieldChanged} value={costCenter} fullWidth={true} />

        <BodyRegular style={{marginBottom: 8}} weight={600} colour={Colours.darkGrey}>{t('hospitality.instructions-description')}</BodyRegular>
        <TextArea ref={textRef} defaultValue={''} value={instructions} onChange={(e) => onTextChange(e.target.value)} />
        <Controls>
          <OutlineButton text={'button.cancel'} click={onCancelClicked} />
          <PrimaryButton text={'hospitality.confirm-instructions'} click={onConfirmClicked} />
        </Controls>
      </Content>
    </>
  )
}

interface Props {
}


const Content = styled.div`
  padding: 24px 56px 24px 56px;
  flex: 1;
  display: flex;
  flex-direction: column;
`

const Controls = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
`

const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  margin-bottom: 2px;
  padding: 4px 8px;
  font-size: 16px;
  font-family: "soleil", sans-serif;
  white-space: pre-wrap;
`

